// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fYbo","textarea":"styles_textarea__3MHTP"};